<h1 mat-dialog-title
    class="draggable-dialogue-header field-conditional-logic-title"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Conditional Logic Rules
</h1>

<div class="configuration-popup">
    <div class="rule-condition-and-actions-div">
        <div class="rule-condition-div">
            <h5>{{this.EditRuleTitle}}</h5>
            <div class="rule-condition-div">
                <div class="source-field-div">
                    <div>Target Fields:</div>
                    <mat-selection-list #targetFieldsList
                                        [(ngModel)]="this.TargetFieldIds"
                                        (ngModelChange)="this.targetFieldChanged(null, $event)"
                                        [disabled]="!this.FieldDefsLoaded"
                                        class="target-fields-mat-selection-list">

                        <mat-list-option *ngFor="let targetField of this.FormTargetFields"
                                         [value]="targetField.id"
                                         [title]="targetField.displayName ? targetField.displayName : targetField.name"
                                         class="target-field-list-option">
                            {{this.getFieldName(targetField)}}
                        </mat-list-option>
                    </mat-selection-list>
                </div>
                <div class="comparison-operator-div">
                    <span class="source-field-span">Grid Column:</span>
                    <mat-select [(ngModel)]="this.TargetFieldChildFieldId"
                                (ngModelChange)="this.targetFieldChildFieldIdChanged($event)"
                                [disabled]="(!this.TargetFieldIsSingleGrid) || (!this.TargetFieldActionAppliesToGrids)"
                                class="target-field-mat-select">
                        <mat-option [value]="0">-- Select Column --</mat-option>
                        <mat-option *ngFor="let childField of this.TargetFieldAvailableChildFields"
                                    [value]="childField.id">
                            {{this.getChildFieldDisplayName(childField)}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="comparison-operator-div">
                    <span class="source-field-span">Properties:</span>
                    <mat-select [(ngModel)]="this.TargetFieldDefaultAttributes"
                                (ngModelChange)="this.targetFieldDefaultAttributesChanged($event)"
                                [disabled]="this.TargetFieldIdsEmpty"
                                class="target-field-mat-select">
                        <mat-option *ngFor="let defaultAttributes of this.AvailableTargetFieldDefaultAttributeValues"
                                    [value]="defaultAttributes.attributeValue">
                            {{defaultAttributes.attributeDisplayName}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="comparison-operator-div">
                    <span class="source-field-span">Action:</span>
                    <mat-select [(ngModel)]="this.TargetFieldAction"
                                (ngModelChange)="this.targetFieldActionChanged(null, $event)"
                                [disabled]="this.TargetFieldIdsEmpty"
                                class="target-field-mat-select">
                        <mat-option *ngFor="let actionValue of this.AvailableFieldActionValues"
                                    [value]="actionValue.actionValue">
                            {{actionValue.actionDisplayName}}
                        </mat-option>
                    </mat-select>
                </div>

            </div>
        </div>
        <div class="rule-actions-div">
            <h5>Rule Conditions</h5>

            <div class="existing-rule-actions-div">
                <kendo-grid [kendoGridBinding]="this.CurrentRuleConditions"
                            (remove)="this.deleteRuleConditionClicked($event)"
                            (cellClick)="this.ruleConditionCellClicked($event)"
                            (cellClose)="this.ruleConditionCellClosed($event)"
                            [selectable]="this.RowSelectable"
                            kendoGridSelectBy
                            [(selectedKeys)]="this.SelectedKeys"
                            [rowReorderable]="true"
                            (rowReorder)="this.ruleConditionRowsReordered($event)"
                            class="rule-conditions-kendo-grid">

                    <kendo-grid-column field="sourceField" title="Source Field" [width]="150">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <mat-select [(ngModel)]="dataItem.sourceFieldId"
                                        (ngModelChange)="this.sourceFieldChanged(dataItem, $event)"
                                        [disabled]="false"
                                        class="source-field-mat-select">
                                <mat-option [value]="0">
                                    -- Select Source Field --
                                </mat-option>

                                <mat-option *ngFor="let sourceField of this.FormSourceFields"
                                            [title]="sourceField.displayName ? sourceField.displayName : ''"
                                            [value]="sourceField.id">
                                    {{this.getFieldName(sourceField)}}
                                </mat-option>
                            </mat-select>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="gridColumn" title="Grid Column"  [width]="150">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <mat-select [(ngModel)]="dataItem.sourceFieldChildFieldId"
                                        (ngModelChange)="this.childFieldNameChanged(dataItem, $event)"
                                        [disabled]="(dataItem.sourceFieldId == 0) || !this.sourceFieldIsGrid(dataItem)"
                                        class="source-child-field-mat-select">
                                <mat-option [value]="0">
                                    -- Select Column --
                                </mat-option>

                                <mat-option *ngFor="let gridColumnField of this.getAvailableGridColumns(dataItem)"
                                            [value]="gridColumnField.id">
                                    {{this.getGridColumnName(gridColumnField)}}
                                </mat-option>
                            </mat-select>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="operator" title="Operator" [width]="120">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <mat-select [(ngModel)]="dataItem.comparisonOperatorId"
                                        (ngModelChange)="this.comparisonOperatorChanged($event)"
                                        [disabled]="dataItem.sourceFieldId == 0"
                                        class="comparison-operator-mat-select">
                                <mat-option [value]="0">
                                    -- Select Operator --
                                </mat-option>
                                <mat-option *ngFor="let comnparisonOperator of this.getAvailableOperators(dataItem)"
                                            [value]="comnparisonOperator.id">
                                    {{comnparisonOperator.name}}
                                </mat-option>
                            </mat-select>
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-column field="comparisonValue" title="Value" [width]="160">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <input matInput
                                   class="comparison-value-input"
                                   type="text"
                                   [(ngModel)]="dataItem.comparisonValue"
                                   (ngModelChange)="this.comparisonValueChanged($event)"
                                   [disabled]="(dataItem.comparisonOperatorId == 0) || this.DisableOperatorValueInput"
                                   placeholder="Enter a value" />
                        </ng-template>
                    </kendo-grid-column>

                    <kendo-grid-command-column>
                        <ng-template kendoGridCellTemplate let-isNew="isNew">
                            <button [disabled]="this.CommandButtonDisabled" class="command-btn" kendoGridRemoveCommand kendoGridFocusable><mat-icon class="row-action-icon" title="delete">delete</mat-icon></button>
                        </ng-template>
                    </kendo-grid-command-column>
                </kendo-grid>


            </div>
            <div mat-dialog-actions class="rule-action-buttons-div">
                <button mat-flat-button
                        color="accent"
                        [disabled]="!this.AddRuleConditionEnabled"
                        (click)="this.addRuleConditionClicked($event)">
                    Add Condition
                </button>

                <button mat-flat-button
                        [disabled]="!this.SaveCurrentRuleEnabled"
                        color="primary"
                        class="theme-primary-btn"
                        style="margin-left: 10px; margin-right: 15px;"
                        (click)="this.saveRuleClicked($event)">
                    Save Rule
                </button>
            </div>

        </div>
    </div>

    <div class="field-conditional-logic-rules-div">
        <h5>Existing Conditional Logic Rules</h5>
        <kendo-grid [kendoGridBinding]="this.ExistingRulesAsCurrentRuleActions"
                    (edit)="this.editExistingRuleActionClicked($event)"
                    (remove)="this.deleteExistingRuleClicked($event)"
                    (cellClick)="this.existingRuleCellClicked($event)"
                    (cellClose)="this.existingRuleCellClosed($event)"
                    [selectable]="this.RowSelectable"
                    kendoGridSelectBy
                    [(selectedKeys)]="this.SelectedKeys"
                    [rowReorderable]="true"
                    (rowReorder)="this.existingRulesRowsRecordered($event)"
                    class="field-conditional-logic-kendo-grid">
            <kendo-grid-column field="targetField" title="Target Field">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{this.getTargetFieldNameFrom(dataItem)}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="actions" title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{this.getRuleActionTextFrom(dataItem)}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="sourceField" title="Source Field">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{this.getSourceFieldNameFrom(dataItem)}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="condition" title="Condition">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{this.getRuleConditionTextFrom(dataItem)}}
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-command-column>
                <ng-template kendoGridCellTemplate let-isNew="isNew">
                    <button [disabled]="this.CommandButtonDisabled" kendoGridEditCommand kendoGridFocusable>
                        <mat-icon class="row-action-icon" title="edit">edit</mat-icon>
                    </button>
                    <button [disabled]="this.CommandButtonDisabled" kendoGridRemoveCommand kendoGridFocusable>
                        <mat-icon class="row-action-icon" title="delete">delete</mat-icon>
                    </button>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
    </div>

    <div mat-dialog-actions
         class="show-buttons-at-right-of-div">
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="this.NoRuleDefined"
                (click)="this.saveClicked()">
            Save Rules and Form
        </button>

        <button mat-flat-button
                [disabled]="false"
                style="margin-left: 10px;"
                (click)="this.cancelClicked()">
            Cancel
        </button>
    </div>

</div>
